import React from 'react'

const About = () => {
  return (
    <section id="about" className="bg-accent py-12 sm:py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-textPrimary">
            About Me
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-primary mx-auto"></div>
        </div>

        {/* Main Content - Mobile First Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-start">
          {/* About Text Section */}
          <div className="order-2 lg:order-1">
            <p className="font-body text-base sm:text-lg mb-4 sm:mb-6 text-textSecondary leading-relaxed">
              Hi, I'm Aryan – a Full-Stack Developer focused on building reliable web applications rather than demo projects. I work across the entire lifecycle of an application — designing database schemas, building REST APIs, handling authentication, and delivering responsive user interfaces.
            </p>
            <p className="font-body text-base sm:text-lg mb-4 sm:mb-6 text-textSecondary leading-relaxed">
              My primary stack is MERN, where I have implemented real-time communication, secure authentication flows, and scalable API structures. I pay particular attention to performance, error handling, and maintainable code structure so applications remain stable as features grow.
            </p>
            <p className="font-body text-base sm:text-lg mb-4 sm:mb-6 text-textSecondary leading-relaxed">
              Alongside JavaScript development, I use Python for automation and data processing tasks such as PDF parsing, OCR-based extraction, and structured data generation. This allows me to build not only user-facing products but also tools that reduce manual operational work.
            </p>
            
            {/* Highlight Box - Mobile Optimized */}
            <div className="bg-backgroundDark p-4 sm:p-6 rounded-lg border-l-4 border-primary">
              <p className="font-body text-base sm:text-lg text-primary font-semibold">
                Currently seeking a software development internship where I can contribute to production systems, collaborate with a development team, and work on real-world engineering problems.

              </p>
            </div>
          </div>

          {/* Tech Stack Section */}
          <div className="order-1 lg:order-2">
            <h3 className="font-heading text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-textPrimary">
              Tech Stack
            </h3>
            
            {/* Tech Stack List - Mobile Optimized */}
            <ul className="space-y-3 sm:space-y-4 font-body text-textSecondary">
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">💻</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Frontend:</strong> React.js, Redux, Tailwind CSS, JavaScript (ES6+), HTML5, CSS3
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">⚙️</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Backend:</strong> Node.js, Express.js, REST API Design, JWT Authentication, WebSockets (Socket.io)
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">🗄️</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Database:</strong> MongoDB, Mongoose, MySQL (basic relational schema design)
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">🗄️</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Python & Automation:</strong> Pandas, Tesseract OCR, PDF Data Extraction, Data Processing Scripts
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">🛠️</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Tools & Workflow:</strong> Git, Postman, Cloudinary, Vite, NPM
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-primary mr-3 text-lg sm:text-xl flex-shrink-0">🎨</span>
                <span className="text-sm sm:text-base">
                  <strong className="text-textPrimary">Extras:</strong> Responsive UI/UX Design, Real-Time Features (WebSockets), Error Handling, API Integration
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
